"use strict";
var import_fs = require("fs");
var import_os = require("os");
var import_path = require("path");
var import_vitest = require("vitest");
var import_getManifest = require("./getManifest");
var testDir;
function writeRoute(relativePath) {
  if (!testDir) {
    testDir = (0, import_fs.mkdtempSync)((0, import_path.join)((0, import_os.tmpdir)(), "one-get-manifest-"));
  }
  var filePath = (0, import_path.join)(testDir, "app", relativePath);
  (0, import_fs.mkdirSync)((0, import_path.dirname)(filePath), {
    recursive: true
  });
  (0, import_fs.writeFileSync)(filePath, "export default function Route() { return null }");
}
(0, import_vitest.afterEach)(function() {
  if (testDir) {
    (0, import_fs.rmSync)(testDir, {
      recursive: true,
      force: true
    });
    testDir = void 0;
  }
});
(0, import_vitest.describe)("getManifest", function() {
  (0, import_vitest.it)("filters ignoredRouteFiles from server route manifests", function() {
    var _ref;
    writeRoute("index.tsx");
    writeRoute("about.tsx");
    writeRoute("contact.test.tsx");
    writeRoute("admin/dashboard.tsx");
    writeRoute("admin/types.ts");
    writeRoute("api/users+api.ts");
    var manifest = (0, import_getManifest.getManifest)({
      routerRoot: (0, import_path.join)(testDir, "app"),
      ignoredRouteFiles: [
        "**/*.test.*",
        "**/types.ts"
      ]
    });
    var files = (_ref = manifest === null || manifest === void 0 ? void 0 : manifest.allRoutes.map(function(route) {
      return route.file;
    })) !== null && _ref !== void 0 ? _ref : [];
    (0, import_vitest.expect)(files).toContain("./index.tsx");
    (0, import_vitest.expect)(files).toContain("./about.tsx");
    (0, import_vitest.expect)(files).toContain("./admin/dashboard.tsx");
    (0, import_vitest.expect)(files).toContain("./api/users+api.ts");
    (0, import_vitest.expect)(files).not.toContain("./contact.test.tsx");
    (0, import_vitest.expect)(files).not.toContain("./admin/types.ts");
  });
});
//# sourceMappingURL=getManifest.test.js.map
